import { render, staticRenderFns } from "./call-calling.vue?vue&type=template&id=36505ffb&"
import script from "./call-calling.vue?vue&type=script&lang=js&"
export * from "./call-calling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports